import { Component, Vue, Inject } from "vue-property-decorator";
import Vue2Filters from "vue2-filters";
import AlertMixin from "@/shared/alert/alert.mixin";
import { mixins } from "vue-class-component";
import DataConvertUtils from "@/commons/DataConvertUtils";
@Component({
  mixins: [Vue2Filters.mixin],
})
export default class HeaderService extends mixins(AlertMixin) {
  private isCollapse: boolean = true;
  private drawer: boolean = false;
  private count = "1";
  private checkClickmenu: boolean = false;
  private dataConvertor: DataConvertUtils = DataConvertUtils.instance;
  private data: any = [];

  constructor() {
    super();
  }

  private rolesAccount: any = [];
  private arr: any = [];
  private dataRoleConvertv1: any = [];
  private c: any = [];
  public async Filter(item) {
    let arr0 = [];
    let ar1 = [];
    let ar2 = [];
    let ar3 = [];
    let ar4 = [];

    item.roles_detail.forEach((e) => e.features.map((x) => arr0.push(x)));
    this.data.forEach((e) => {
      let chil = [];
      e.childrens.forEach((b) => {
        arr0.find((c) => {
          if (c.id === b.id) {
            chil.push(b);
          }
        });
      });
      ar1.push({
        path: e.path,
        id: e.id,
        name: e.name,
        icon: e.icon,
        childrens: chil,
      });
    });
    ar1.forEach((e) => {
      arr0.forEach((h) => {
        if (h.id === e.id) {
          ar2.push(e);
        }
      });
      if (e.childrens.length > 0) {
        ar2.push({
          ...e,
          childrens: [
            {
              id: e.id,
              name: e.name,
              path: e.path,
              icon: e.icon,
            },
            ...Array.from(new Set(e.childrens)),
          ],
        });
      }
    });
    this.rolesAccount = Array.from(new Set(ar2));
  }
  public created() {
    this.data = this.menuDefault;
    this.rolesAccount = [];
    const user = JSON.parse(localStorage.getItem("user"));
    this.Filter(user);
    this.count = this.getCurrenMenu();
    this.demomixis();
  }
  /*  public getCurrenMenu() {
    let index = "";
    const currentPath = this.$router.history.pending?.path;

    if (currentPath) {
      let url_curren = currentPath.split("/");
      for (var i = 0; i < this.rolesAccount.length; i++) {
        if (this.rolesAccount[i].childrens.length < 1) {
          if (this.rolesAccount[i].path == `/${url_curren[1]}`) {
            index = (i + 1).toString();
            break;
          }
        } else {
          for (var j = 0; j < this.rolesAccount[i].childrens.length; j++) {
            if (this.rolesAccount[i].childrens[j].path == `/${url_curren[1]}`) {
              index = i + 1 + "-" + (j + 1);
              break;
            }
          }
        }
      }
    }

    return index == "" ? "1" : index;
  }*/
  public getCurrenMenu() {
    // @ts-ignore
    let url_curren = this.$router.history.pending.path.split("/");
    let index = "";
    for (var i = 0; i < this.rolesAccount.length; i++) {
      if (this.rolesAccount[i].childrens.length < 1) {
        if (this.rolesAccount[i].path == `/${url_curren[1]}`) {
          index = (i + 1).toString();
          break;
        }
      } else {
        for (var j = 0; j < this.rolesAccount[i].childrens.length; j++) {
          if (this.rolesAccount[i].childrens[j].path == `/${url_curren[1]}`) {
            index = i + 1 + "-" + (j + 1);
            break;
          }
        }
      }
    }
    return index == "" ? "1" : index;
  }
  public handleUnClick() {}
  public demo() {
    this.checkClickmenu = !this.checkClickmenu;
    this.$store.commit("setcheckOpen", false);
  }
  public mouseover() {
    this.checkClickmenu = false;
  }
  public backToHome() {
    this.$router.push("/home");
    // this.test();
  }
  public handleOpen() {
    this.drawer = true;
    // this.test();
  }
  // public test(){
  //   this.count = this.count + 1;
  // }
  public handleClickv2(id1, id2, subcat) {
    if (subcat.id == 60) {
      window.open("https://dulieuvienthong.vnta.gov.vn/decision-his?size=20&page=1&sort=locked,asc&sort=id,desc", "_blank");
      // // window.close();
      this.backToHome();
      window.location.reload();
    } else if (subcat.id == 61) {
      window.open("https://dulieuvienthong.vnta.gov.vn/lic-cpn?page=1&size=20", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else if (subcat.id == 62) {
      window.open("https://dulieuvienthong.vnta.gov.vn/lic-cpn?page=1&size=20", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else if (subcat.id == 63) {
      window.open("https://dulieuvienthong.vnta.gov.vn/lic-cpn?page=1&size=20", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else if (subcat.id == 64) {
      window.open("https://dulieuvienthong.vnta.gov.vn/sea-cable-list", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else {
      // Xử lý điều hướng bình thường
      this.count = id2 != undefined ? (id1 + 1).toString() + "-" + (id2 + 1).toString() : (id1 + 1).toString();
      this.drawer = false;
    }
  }
  public handleClick(id1, id2?: number) {
    this.count = id2 != undefined ? (id1 + 1).toString() + "-" + (id2 + 1).toString() : (id1 + 1).toString();
    this.drawer = false;
  }

  public handleClosePopup(path, subcat) {
    if (subcat != null && subcat.id == 60) {
      window.open("https://dulieuvienthong.vnta.gov.vn/decision-his?size=20&page=1&sort=locked,asc&sort=id,desc", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else if (subcat != null && subcat.id == 61) {
      window.open("https://dulieuvienthong.vnta.gov.vn/lic-cpn?page=1&size=20", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else if (subcat != null && subcat.id == 62) {
      window.open("https://dulieuvienthong.vnta.gov.vn/lic-cpn?page=1&size=20", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else if (subcat != null && subcat.id == 63) {
      window.open("https://dulieuvienthong.vnta.gov.vn/lic-cpn?page=1&size=20", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else if (subcat != null && subcat.id == 64) {
      window.open("https://dulieuvienthong.vnta.gov.vn/sea-cable-list", "_blank");
      // window.close();
      this.backToHome();
      window.location.reload();
    } else {
      this.$store.commit("setcheckOpen", false);
      this.count = path;
      this.drawer = false;
    }
  }
  // public handleOpen(key, keyPath) {
  //   console.log(key, keyPath);
  // }
  // public handleClose(key, keyPath) {
  //   console.log(key, keyPath);
  // }

  // public handleOpen(key, keyidx) {
  //   this.isCollapse = true;
  //     document.getElementById("message").style.maxWidth = "70px";
  //     document.getElementById("message").style.padding = "0px";
  //     document.getElementById("content-type").style.display = "none";

  // }

  // public handleClose(key, keyidx) {
  //   this.isCollapse = false;
  //   document.getElementById("message").style.maxWidth = "270px";
  //   document.getElementById("message").style.paddingRight = "15px";
  //   document.getElementById("message").style.paddingLeft = "15px";
  //   document.getElementById("content-type").style.display = "flex";
  // }
}
